export default "__VITE_ASSET__9ef566c6__"